/* Program Name: CartContext.js
 **  Description: a component that handles the state of the cart for the
 **               entire application
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-04-19  STT  Initial program
 *********************************************************************************/

/**React hooks imports */
import React, { useContext, createContext, useState } from 'react'

/**Cookies import */
//DOCS: https://github.com/js-cookie/js-cookie
import Cookies from 'js-cookie'
import { getCartCount } from '../API/generalAPI'

/**setCartCookie */
/**removes the current cart cookie and replaces it with the newly provided cart */
export const setCartCookie = (cart) => {
  Cookies.remove('cart')
  Cookies.set('cart', cart, { expires: 14 })
}

/**getCartCookie */
/**uses the Cookies package to get and serialize the cart cookie and return it as a JSON object */
export const getCartCookie = () => {
  const cartCookie = Cookies.get('cart')

  if (cartCookie === undefined) {
    return { qty: 0, orders: [] }
  } else {
    return JSON.parse(cartCookie)
  }
}

/**creating a context to hold the user authentication info */
//DOCS: https://reactjs.org/docs/context.html
const CartContext = createContext(getCartCookie())

/**creating a hook which will allow us to use this context */
export function useCart() {
  return useContext(CartContext)
}

/**creating a provider to wrap around the app to provide access to the user to all children */
export default function CartProvider({ children }) {
  /**user object */
  const [currentCartCnt, setCurrentCartCnt] = useState(0)

  const getCartCnt = () => {
    getCartCount()
      .then((response) => {
        setCurrentCartCnt(response.data.ttCartMeta[0].totQty)
      })
      .catch((error) => {})
      .then(() => {})
  }

  /**values that will be avalible through the provider */
  const value = {
    currentCartCnt,
    getCartCnt,
  }

  /**rendering method */
  return <CartContext.Provider value={value}>{children}</CartContext.Provider>
}
